import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

export interface TopbarSlotsApi {
  left: ReadOnlyStore<HTMLElement | null>;
  center: ReadOnlyStore<HTMLElement | null>;
  setLeft(el: HTMLElement | null): void;
  setCenter(el: HTMLElement | null): void;
  leftClaimed: ReadOnlyStore<boolean>;
  centerClaimed: ReadOnlyStore<boolean>;
  setLeftClaimed(v: boolean): void;
  setCenterClaimed(v: boolean): void;
}

export function createTopbarSlotsApi(): TopbarSlotsApi {
  const left = createStore<HTMLElement | null>(null);
  const center = createStore<HTMLElement | null>(null);
  const leftClaimed = createStore<boolean>(false);
  const centerClaimed = createStore<boolean>(false);
  return {
    left: left.store,
    center: center.store,
    setLeft: (el) => left.set(el),
    setCenter: (el) => center.set(el),
    leftClaimed: leftClaimed.store,
    centerClaimed: centerClaimed.store,
    setLeftClaimed: (v) => leftClaimed.set(v),
    setCenterClaimed: (v) => centerClaimed.set(v),
  };
}
